import * as React from 'react';
// import "./.less";

export interface ScreenSmallProps {
}

export const ScreenSmall = (props: ScreenSmallProps) =>
    <div style={{ textAlign: "center", fontSize: 18, padding: 40 }}>
        <img src="./assets/mobile-version-to-desktop-version.png" width="80%" />
        <br />
        <br />
        Your screen is too small, ProfitPoint is best used on a larger screen.
        <br />
        <br />
        Please increase the size of your window, or change to a different device
</div>